import { createReducer } from 'utilities';
import * as TYPES from './constants';

const initialState = {
  results: [],
  fetching: false,
  error: null
};
const reducer = createReducer(initialState, {
  [TYPES.REQUEST](state) {
    return {
      ...state,
      fetching: true
    }
  },
  [TYPES.FAILURE](state, action) {
    return {
      ...state,
      fetching: false,
      error: action.error || true
    }
  },
  [TYPES.SUCCESS](state, { categories }) {
    return {
      ...state,
      fetching: false,
      error: false,
      results: categories
    }
  },
});

export default reducer;




// WEBPACK FOOTER //
// ./src/ducks/categoriesScaffolding/reducer.js